<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Car Loan details</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Select a product</mat-label>
          <mat-select placeholder="Select a product" formControlName="carLoanProduct">
            <mat-option [value]="4">
              Secured loan
            </mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanProduct'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Loan purpose</mat-label>
          <mat-select placeholder="Loan purpose" formControlName="carLoanPurpose">
            <mat-option [value]="4">
              Personal car loan
            </mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanPurpose'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <app-car-search-partial
          [formGroup]="formGroup"
          [fieldName]="'carType'"
        ></app-car-search-partial>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Car Loan Amount and Fees</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Amount Inc GST</mat-label>
          <input matInput placeholder="Amount Inc GST" type="number" formControlName="carLoanAmtIncGst">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanAmtIncGst'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Deposit</mat-label>
          <input matInput placeholder="Deposit" type="number" formControlName="carLoanDeposit">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanDeposit'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Subtotal</mat-label>
          <input matInput placeholder="Subtotal" type="number" formControlName="carLoanSubtotal" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanSubtotal'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-sm-4 d-flex justify-content-end">
        <mat-checkbox formControlName="carLoanOriginationCheck" class="d-flex" (click)="toggleOriginatorFee()">No origination fee to be charged</mat-checkbox>
        <mat-error>
          <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'carLoanOriginationCheck'"
          ></app-validation-partial>
        </mat-error>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Origination fee (inc GST)</mat-label>
          <input matInput placeholder="Origination fee (inc GST)" type="number" formControlName="carLoanOriginationFee">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanOriginationFee'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">

      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Application fee</mat-label>
          <input matInput placeholder="Application fee" type="number" formControlName="carLoanApplicationFee" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanApplicationFee'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Subtotal + Fees</mat-label>
          <input matInput placeholder="Subtotal + Fees" type="number" formControlName="carLoanSubtotalAndFees" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanSubtotalAndFees'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4"></div>
      <div class="col-sm-4 d-flex justify-content-end">
        <mat-checkbox formControlName="carLoanBrokerCheck" class="d-flex" (click)="toggleBrokerageFees()">No broker fee to be charged</mat-checkbox>
        <mat-error>
          <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'carLoanBrokerCheck'"
          ></app-validation-partial>
        </mat-error>
      </div>
      <div class="col-sm-2">
        <mat-form-field appearance="outline">
          <mat-label>Brokerage percent (inc GST)</mat-label>
          <input matInput placeholder="Brokerage percent (inc GST)" type="number" formControlName="carLoanBrokeragePercent" ng-model='val | number: 2' readonly>
          <span matSuffix>%</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanBrokeragePercent'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-2">
        <mat-form-field appearance="outline">
          <mat-label>Brokerage amount (inc GST)</mat-label>
          <input matInput placeholder="Brokerage amount (inc GST)" type="number" formControlName="carLoanBrokerageAmount">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanBrokerageAmount'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-8">

      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Total loan amount</mat-label>
          <input matInput placeholder="Total loan amount" type="number" formControlName="carLoanTotalAmount" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanTotalAmount'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Repayment and loan term</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Select repayment</mat-label>
          <mat-select placeholder="Select repayment" formControlName="carLoanRepaymentFrequency">
            <mat-option [value]="1">
              Monthly
            </mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanRepaymentFrequency'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field appearance="outline">
          <mat-label>Select loan term</mat-label>
          <mat-select placeholder="Select loan term" formControlName="carLoanTerm">
            <mat-option [value]="3">
              3 years
            </mat-option>
            <mat-option [value]="5">
              5 years
            </mat-option>
          </mat-select>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanTerm'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-2">
        <mat-form-field appearance="outline">
          <mat-label>Balloon amount</mat-label>
          <input matInput placeholder="Balloon amount" type="number" formControlName="carLoanBalloonAmount" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanBalloonAmount'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-2">
        <mat-form-field appearance="outline">
          <mat-label>Balloon percent</mat-label>
          <input matInput placeholder="Balloon percent" type="number" formControlName="carLoanBalloonPercent" readonly>
          <span matSuffix>%</span>
          <mat-error>
            <app-validation-partial
                [formGroup]="formGroup"
                [fieldName]="'carLoanBalloonPercent'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
